import React, { useState, useEffect } from "react";
import onlineBadhoLogo from "../../../../images/onlinebadho.png";

const HeaderLiquid = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // Close mobile menu when navigating
    setIsMobileMenuOpen(false);

    // First try to find element by ID
    let element = document.getElementById(sectionId);

    // If not found by ID, try to find by a more specific selector
    if (!element) {
      switch (sectionId) {
        case "hero":
          element =
            document.querySelector('[id="hero"]') ||
            document.querySelector("section");
          break;
        case "features":
          element =
            document.querySelector('[id="features"]') ||
            document.querySelector(".features");
          break;
        case "pricing":
          element =
            document.querySelector('[id="pricing"]') ||
            document.querySelector(".pricing");
          break;
        case "testimonials":
          element =
            document.querySelector('[id="testimonials"]') ||
            document.querySelector(".testimonials");
          break;
        case "contact":
          element =
            document.querySelector('[id="contact"]') ||
            document.querySelector(".contact");
          break;
        default:
          element = document.querySelector('[id="hero"]');
      }
    }

    if (element) {
      const headerHeight = 80;
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    } else {
      console.log(`Element with ID "${sectionId}" not found`);
    }
  };

  const handleLogoClick = () => {
    scrollToSection("hero");
  };

  return (
    <header className={`liquid-glass-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="liquid-glass-header-content">
        {/* Logo Section */}
        <div className="liquid-glass-logo-section">
          <div className="liquid-glass-logo" onClick={handleLogoClick}>
            <div className="logo-image-container">
              <img
                src={onlineBadhoLogo}
                alt="OnlineBadho Logo"
                className="logo-image"
              />
            </div>
            <span className="logo-text">OnlineBadho</span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="liquid-glass-nav">
          <button
            className="nav-glass-item"
            onClick={() => scrollToSection("hero")}
          >
            <span>Home</span>
            <div className="nav-liquid-indicator"></div>
          </button>
          <button
            className="nav-glass-item"
            onClick={() => scrollToSection("features")}
          >
            <span>Features</span>
            <div className="nav-liquid-indicator"></div>
          </button>
          <button
            className="nav-glass-item"
            onClick={() => scrollToSection("pricing")}
          >
            <span>Pricing</span>
            <div className="nav-liquid-indicator"></div>
          </button>
          <button
            className="nav-glass-item"
            onClick={() => scrollToSection("testimonials")}
          >
            <span>Reviews</span>
            <div className="nav-liquid-indicator"></div>
          </button>
          <button
            className="nav-glass-item"
            onClick={() => scrollToSection("contact")}
          >
            <span>Contact</span>
            <div className="nav-liquid-indicator"></div>
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <div className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>

        {/* CTA Button */}
        <div className="liquid-glass-header-cta">
          <button
            className="cta-glass-button"
            onClick={() => scrollToSection("contact")}
          >
            <span>Get Started</span>
            <div className="cta-liquid-glow"></div>
          </button>
        </div>
      </div>

      {/* Floating Glass Orbs */}
      <div className="header-floating-orbs">
        <div className="floating-orb orb-1"></div>
        <div className="floating-orb orb-2"></div>
        <div className="floating-orb orb-3"></div>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav-menu ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="mobile-nav-content">
          <button
            className="mobile-nav-item"
            onClick={() => scrollToSection("hero")}
          >
            <span>Home</span>
          </button>
          <button
            className="mobile-nav-item"
            onClick={() => scrollToSection("features")}
          >
            <span>Features</span>
          </button>
          <button
            className="mobile-nav-item"
            onClick={() => scrollToSection("pricing")}
          >
            <span>Pricing</span>
          </button>
          <button
            className="mobile-nav-item"
            onClick={() => scrollToSection("testimonials")}
          >
            <span>Reviews</span>
          </button>
          <button
            className="mobile-nav-item"
            onClick={() => scrollToSection("contact")}
          >
            <span>Contact</span>
          </button>
          <button
            className="mobile-nav-cta"
            onClick={() => scrollToSection("contact")}
          >
            <span>Get Started</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeaderLiquid;
